import Text from "../../../components/ui/typography/Text.jsx";
import s from "./AmazonAssociateFooter.module.css";

/**
 * Required Amazon Associates disclosure. Render once, at the very bottom of the
 * scrollable content, on any screen that shows a product carousel (reco cards
 * link out to Amazon). Sits inside the normal document flow — never fixed/sticky —
 * so it can't cover content or the fixed bottom nav; it simply scrolls into view
 * after everything else. Bottom margin includes --gg-scroll-end-bounce-buffer so
 * iOS rubber-band overscroll cannot tuck the line under the fixed nav dock.
 *
 * `inset`: horizontal padding (px) this component itself contributes. Screens
 * whose scroll container already applies its own side padding around this
 * footer should pass a smaller `inset` so the *total* left/right gap to the
 * screen edge stays the same everywhere — keeping the disclosure on one line
 * with matching spacing on every screen, regardless of container padding.
 */
export default function AmazonAssociateFooter({ inset = 24 }) {
  return (
    <Text
      as="p"
      variant="paragraphSm"
      align="center"
      className={s.root}
      style={{ "--gg-aaf-inset": `${inset}px` }}
    >
      As an Amazon Associate I earn from qualifying purchases.
    </Text>
  );
}
